import { getQuoteForm, getPremiumCalculationUg, getSelectedCover } from '../../../selectors/ugMotorInsurance/quote';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAgentForm } from '../../../selectors/ugMotorInsurance/travelAgentModal';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';
import {
    setCustomerIdValue,
    setVehicleRecordId,
    setInsuranceQuotationId,
} from '../../../actions/ugMotorInsurance/quote';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const submitQuoteService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const state = store.getState();

                const selectedCover = getSelectedCover(state);

                let resp;

                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await makeComprehensiveSubmission(state);

                    if (resp.data) {
                        store.dispatch(setCustomerIdValue(resp.data.data.insurance.id));
                        store.dispatch(setVehicleRecordId(resp.data.data.vehicle.id));
                        store.dispatch(setInsuranceQuotationId(resp.data.data.quotation.id));

                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await makeThirdPartySubmission(state);

                    store.dispatch(setCustomerIdValue(resp.data.data.id));

                    store.dispatch(apiTransitionPayloadCollection.initial());
                }
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const comprehensivePayloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const premium = getPremiumCalculationUg(state);

    const quotationPayload = {
        phoneNumber: quotation.phoneNumber?.value ? quotation.phoneNumber?.value : 'N/A',
        make: parseInt(quotation.carMake.value.id) || parseInt(quotation.carModel.value.id),
        model: parseInt(quotation.carModel.value.id),
        yearOfManufacture: quotation.yearOfManufacture.value,
        coverStartDate: quotation.coverStartDate.value,
        valuedBy: quotation.carValuer.value || 'NA',
        valuationDone: quotation.isCarValued.value === 'yes' ? true : false,
        use: quotation.carUse.value,
        alarmInstalled: quotation.hasAlarm.value === 'yes' ? true : false,
        trackerInstalled: quotation.trackingSystem.value === 'yes' ? true : false,
        valuationValue: quotation.valuation.value || 0,
        annualPremium: premium.value.premium || premium.value.totalPremium,
        basePremiumRate: premium.value.basePremiumRate || 0,
        countryCode: gatsbyStack.toUpperCase(),
        carValue: quotation.valuation.value || 0,
        referredByAgent: agent.name?.value?.name ? true : agent.name?.value ? true : false,
        agentCode: agent.name?.value?.agentCode || 'N/A',
        agentName: agent.name?.value?.name || 'N/A',
        omRescuePlus: quotation.omRescuePlus.value || false,
        violenceAndTerrorismCovered: quotation.violenceAndTerrorism.value || false,
        violenceAndTerrorismFees: 0,
        uncommonRisksCovered: false,
        uncommonRisksCoveredFees: 0,
    };

    return {
        ...quotationPayload,
    };
};

const makeComprehensiveSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/quote';

        return await axios.post(url, comprehensivePayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const thirdPartyPayloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const premium = getPremiumCalculationUg(state);

    const quotationPayload = {
        phoneNumber: quotation.phoneNumber?.value ? quotation.phoneNumber?.value : 'N/A',
        make: parseInt(quotation.carMake.value.id) || parseInt(quotation.carModel.value.id),
        model: parseInt(quotation.carModel.value.id),
        yearOfManufacture: quotation.yearOfManufacture.value,
        coverStartDate: quotation.coverStartDate.value,
        use: quotation.carUse.value,
        annualPremium: premium.value.premium || premium.value.totalPremium,
        basePremiumRate: premium.value.basePremiumRate || 0,
        countryCode: gatsbyStack.toUpperCase(),
        valuedBy: quotation.carValuer.value || 'NA',
        valuationDone: quotation.isCarValued.value === 'yes' ? true : false,
        carValue: quotation.valuation.value || 0,
        valuationValue: quotation.valuation.value || 0,
        agentCode: agent.name?.value?.agentCode || 'N/A',
        agentName: agent.name?.value?.name || 'N/A',
        referredByAgent: agent.name?.value?.name ? true : agent.name?.value ? true : false,
    };

    return {
        ...quotationPayload,
    };
};

const makeThirdPartySubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/third-party/quote';

        return await axios.post(url, thirdPartyPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
